import { getCurrentUserId } from '@helpers/firebase/Auth';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function addBlockedUser(userId: string) {
  const currentUserId = getCurrentUserId();
  await db.setDoc(db.doc(firestore, 'users', currentUserId, 'blockedUsers', userId), {
    userId,
    createdAt: db.serverTimestamp(),
  });
}

export async function deleteBlockedUser(userId: string) {
  const currentUserId = getCurrentUserId();
  await db.deleteDoc(db.doc(firestore, 'users', currentUserId, 'blockedUsers', userId));
}

export function listenToBlockedUserIds(
  onSnapshot: (userIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  const currentUserId = getCurrentUserId();
  const q = db.query(db.collection(firestore, 'users', currentUserId, 'blockedUsers'));
  const onNext = (snap: db.QuerySnapshot<db.DocumentData>) => {
    const blockedUserIds = new Set(snap.docs.map((doc) => doc.id));
    return onSnapshot(blockedUserIds);
  };
  return db.onSnapshot(q, onNext, onError);
}
